module.exports = __webpack_public_path__ + "static/img/SNK2.b16e8fb2.jpg";